import React from "react";
import { CheckCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function WhyChooseGp2bcExpress() {
  const reasons = [{
    id: 1,
    title: "Proven Migration Frameworks",
    description: "Repeatable, battle-tested processes designed specifically for mid-sized North American businesses migrating from Dynamics GP to Business Central."
  }, {
    id: 2,
    title: "Audit-Ready Results",
    description: "Clean cheque remittance templates, precisely mapped data, and professionally branded outputs that meet compliance standards."
  }, {
    id: 3,
    title: "Scalable Pricing in CAD",
    description: "Flexible packages starting at $7,500 CAD, tailored to your migration complexity with transparent Canadian dollar pricing."
  }, {
    id: 4,
    title: "Comprehensive Documentation",
    description: "Polished proposals, detailed templates, and thorough onboarding materials to ensure a smooth transition for your team."
  }];
  return <section className="bg-background py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <h2 className="font-display text-3xl font-bold tracking-tight text-foreground lg:text-4xl animate-fade-in-up">
            Why Choose GP2BC Express?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-foreground/80 animate-fade-in-up-delay-100">GP2BC Express.com specializes in fast, reliable ERP migrations across North America. We help businesses transition from Microsoft Dynamics GP to Dynamics 365 Business Central with precision, speed, and results you can trust.</p>

          <div className="mt-12 grid gap-6 sm:grid-cols-2 animate-fade-in-up-delay-200">
            {reasons.map((reason, i) => <Card key={reason.id} data-index={i} className="border-border bg-card shadow-soft hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <CardHeader>
                  <div className="mb-3 inline-flex size-10 items-center justify-center rounded-md bg-primary/10">
                    <CheckCircle className="size-5 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {reason.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-foreground/70 leading-relaxed">
                    {reason.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}